<template>
  <div class="elementHeights" :key="`tab_content_3` + $store.state.calculatorData.calculatorPages[3].disabled">
    <div class="row">
      <div class="col-md-6">
        <h2>{{ $t(`elementHeights.title`)}}</h2>
      </div>
      <div class="col-md-6 md-align-right" v-if="elementForm !== ''">
        <p>({{$t(`globals.currentSelectedForm`)}} <strong> {{$t(`elementForm.`+ elementForm +`.pdfTitle`)}}</strong>)</p>
      </div>
    </div>
    <b-button @click="explanationClick()" v-b-toggle.explanation-content-elementHeights variant="primary" class="explanation"> <span v-html="$t(`globals.explanation`)"></span></b-button>
    <b-collapse id="explanation-content-elementHeights" class="explanation-content">
      <b-card>
        <p v-html="$t(`elementHeights.infoText`)"></p>
      </b-card>
    </b-collapse>
    <div class="row">
      <div class="technical-draw col-md-5 d-none d-md-block align-self-center">
        <TechnicalDrawing step="elementHeights" :type="`elementheights_`+elementForm" />
      </div>
      <div class="col-md-7">

        <div class="technical-draw d-md-none">
          <TechnicalDrawing step="elementHeights" :type="`elementheights_`+elementForm" />
        </div>
        <div v-if="elementForm !== ''">
          <StoSlider name="c" tab="elementHeights" />
          <div
            v-if="elementForm === 'jaka'"
            class="slider-wrapper input-container highlight-box"
            @mouseenter="mouseEnter('d1')"
            @mouseleave="mouseLeave('d1')"
          >
            <div class="row space-between">
              <div class="col-12">
                <span v-html="$t('elementHeights.d1Label')"></span>
              </div>
              <div class="col-12">
                <div class="d1-radio-group">
                  <label class="d1-radio-option" :class="{ active: d1 === 240 }" for="d1-option-240">
                    <input
                      id="d1-option-240"
                      type="radio"
                      name="d1-option"
                      :checked="d1 === 240"
                      @change="updateD1ByRadio(240)"
                    />
                    <span>240 mm</span>
                  </label>
                  <label class="d1-radio-option" :class="{ active: d1 === 280 }" for="d1-option-280">
                    <input
                      id="d1-option-280"
                      type="radio"
                      name="d1-option"
                      :checked="d1 === 280"
                      @change="updateD1ByRadio(280)"
                    />
                    <span>280 mm</span>
                  </label>
                </div>
              </div>
              <div v-if="$store.state.calculatorData.errors['d1'] === 'd1BiggerThenC'" class="col-12 error">
                {{ $t('globals.d1BiggerC') }}
              </div>
            </div>
          </div>
          <StoSlider v-else name="d1" tab="elementHeights" />
        </div>

        <div
          class="slider-wrapper input-container highlight-box calculated-box"
          @mouseenter="mouseEnter('d2')"
          @mouseleave="mouseLeave('d2')"
        >
          <div class="row space-between">
            <div class="col-md-8">
                <span v-html="$t(`variablesNice.d2`)"></span>
                <p>{{ elementForm === 'jaka' ? 'D2 = C - D1' : 'D2 = C - D' }}</p>
            </div>
            <div class="col-12 d-md-none text-align-right spacebottom-to-sm">
              <input type="number" :min="min" :max="max" :value="d2" class="slider-input disabled" disabled="disabled"> mm
            </div>
            <div class="col-md-4 d-none d-md-block">
              <input type="number" :min="min" :max="max" :value="d2" class="slider-input disabled" disabled="disabled"> mm
            </div>

            <div v-if="$store.state.calculatorData.errors['d2'] === 'min'" class="col-12 error">
              {{$tc(`elementHeights.d2errorMin`, min, {min: calculatorMin.d2()})}}
              <!-- {{ trackingErrors() }} -->
            </div>
            <div v-if="$store.state.calculatorData.errors['d2'] === 'max'" class="col-12 error">
              {{$tc(`elementHeights.d2errorMax`, max, {max: calculatorMax.d2()})}}
              <!-- {{ trackingErrors() }} -->
            </div>
            <div v-if="$store.state.calculatorData.errors['d2'] === 'steps'" class="col-12 error">
              {{ $t('elementHeights.errorStep10') }}
              <!-- {{ trackingErrors() }} -->
            </div>
          </div>
        </div>

        <div class="info-wrapper">
          <div v-if="$store.state.calculatorData.warnings.elementHeights">
            <p v-if="$store.state.calculatorData.warnings.elementHeights.higherThanStandard" class="info" v-html="$t('elementHeights.triggerInfo1')"></p>
            <p v-if="$store.state.calculatorData.warnings.elementHeights.specialConfigD2"  class="info" v-html="$tc('elementHeights.triggerInfo2', $store.state.calculatorData.warnings.elementHeights.specialConfigD2, {value: $store.state.calculatorData.warnings.elementHeights.specialConfigD2} )"></p>
          </div>
        </div>
      </div>
    </div>
    <StepNavi thisPage="4" :key="`navi_tab4_`+ $store.state.calculatorData.calculatorPages[4].disabled"/>
  </div>
</template>

<script>
import StoSlider from './StoSlider.vue'
import TechnicalDrawing from './TechnicalDrawing.vue'
import StepNavi from './StepNavi.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    StoSlider,
    TechnicalDrawing,
    StepNavi
  },
  data () {
    return {
      min: Number,
      max: Number,
      textTriggerOpen: false
    }
  },
  computed: {
    ...mapGetters([
      'd2',
      'd1',
      'calculatorMin',
      'calculatorMax',
      'disabledStatusTab4',
      'elementForm'
    ])
  },
  methods: {
    mouseEnter: function (name) {
      var list = document.getElementsByClassName('highlight-' + name)
      for (var i = 0; i < list.length; i++) {
        list[i].classList.add('active')
      }
    },
    mouseLeave: function (name) {
      var list = document.getElementsByClassName('highlight-' + name)
      for (var i = 0; i < list.length; i++) {
        list[i].classList.remove('active')
      }
    },
    updateD1ByRadio: function (value) {
      const rootApp = this.$root && this.$root.$children && this.$root.$children['0']
      if (rootApp) {
        rootApp.userDidAction = true
      }
      this.$store.dispatch('didInputFkt', {
        key: 'd1',
        value: value,
        validate: true
      })
    },
    explanationClick: function () {
      if (this.textTriggerOpen) {
        this.textTriggerOpen = false
      } else {
        this.$root.$children['0'].userDidAction = true
        this.textTriggerOpen = true
        let tabName = 'elementHeights'
        let gtmEventLabel = this.$t(tabName + '.virtualPageTitle')
        let virtualPageURL = '/' + this.$t(tabName + '.virtualPageURL')
        let virtualPageTitle = this.$t(tabName + '.virtualPageTitle')
        this.$root.$children['0'].globalGTMFkt('JKK-Events', 'Erläuterung', 'Button', gtmEventLabel, '', virtualPageURL, virtualPageTitle)
      }
    }
  },
  mounted: function () {
    // console.log('--- elementHeights rendert ---')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.d1-radio-group {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 0.75rem;
}

.d1-radio-option {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 150px;
  margin: 0;
  padding: 0.75rem 1rem;
  border: 2px solid #b8b8b8;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.2s ease, background-color 0.2s ease;
}

.d1-radio-option input {
  position: absolute;
  inset: 0;
  opacity: 0;
  margin: 0;
  cursor: pointer;
}

.d1-radio-option span {
  font-size: 2rem;
  line-height: 1.2;
}

.d1-radio-option.active {
  border-color: #7a7a7a;
  background: #d3d3d3;
}

.d1-radio-option:focus-within {
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.12);
}
</style>
